import Button from '../Button.class';

export default class StudyHeader extends Button {
	public mounted(): void {
		this.animateButton();
	}
}
